/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.navigation.controllers', [
  'acme.common.service.posConfig',
  'colorpicker.module',
  'acme.common.service.api'
])

.controller('PosCreateNavigationController', ['$scope', 'ApiService', 'PosConfigService', function($scope, ApiService, PosConfigService) {

    $scope.posCreateNavigation = {

      model: [],
      current: {},

      init: function() {

        $scope.$on('PosCreateController::Save', this.onPosCreateSave);
        $scope.$on('PosCreateController::UpdateModel', this.onPosCreateUpdateModel);

        this.getNavigation();
      },

      getNavigation: function() {
        var self = $scope.posCreateNavigation;
        self.model = PosConfigService.navigation.getModel();
        self.model.sort(self.sortButtons);
        self.getButtonInfo(self.model[0]);
      },

      sortButtons: function (a, b) {
        return a.order - b.order;
      },

      showNickname: function(button) {
        if (button.text) {
          return button.name.toLowerCase() !== button.text.toLowerCase();
        } else {
          return false;
        }
      },

      getButtonInfo: function(button) {
        this.current = button;
        angular.element("#pos-create-navigation-form-text").focus();
      },

      toggleDisplay: function(button) {
        if(button.type !== 'retail') {
          button.display = !button.display;
        }
      },

      onDrop: function(target, source) {
        var self = $scope.posCreateNavigation;
        self.model[source].order = target;
        self.model[target].order = source;
        self.model.sort(self.sortButtons);
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onPosCreateSave: function (e, data) {
        var self = $scope.posCreateNavigation;
        PosConfigService.navigation.setModel(self.model);
      },

      onPosCreateUpdateModel: function(e, data) {
        var self = $scope.posCreateNavigation;
        PosConfigService.navigation.setModel(PosConfigService.navigation.getModel());
        self.getNavigation();
      }


    };

    $scope.posCreateNavigation.init();

}]);
